module.exports = __webpack_public_path__ + "media/assets/arrow-8a0105b1dc8c0092fc91a579ebed6ecffd9540a135aa0c0e6b39ae905629039b.svg";